export function getFirstNonCompletedChallenge(challenges: any[]) {
  for (let i = 0; i < challenges.length; i++) {
    if (challenges[i].status !== "COMPLETED") {
      return i;
    }
  }
  return 0;
}
